<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-06-16 14:00:08
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-30 16:17:12
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\SystemSettings\LabelManage\index.vue
-->
<template>
  <!-- 标签管理 -->
  <div class="label">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <div class="search">
        <el-input v-model="searchForm.redundant" placeholder="请输入标签名称" size="small"
          style="width: 200px;margin-right: 15px">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button size="small" style="margin-left:20px" @click="resetClick">重置</el-button>
        <el-button type="primary" size="small" style="background:#1A7BFC;border-color:#1A7BFC"
          @click="searchBtn">搜索</el-button>
      </div>
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="标准自定义标签" name="1"></el-tab-pane>
          <el-tab-pane label="医生自定义标签" name="2"></el-tab-pane>
          <el-tab-pane v-if="$store.state.userPlatForm === 'organization'" label="标签模板" name="3"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="container">
      <div class="content">
        <div class="system" v-loading="loading" v-if="activeName == 1">
          <div class="left">
            <div class="title-all">
              <div class="header">
                <p></p>
                <h1>标签分类</h1>
              </div>
              <div class="btn-box">
                <div class="tab-box">
                  <div :class="curIndex == 1 ? 'checked' : ''" @click="changeSymp(1)">dsicm</div>
                  <div :class="curIndex == 2 ? 'checked' : ''" @click="changeSymp(2)">企微</div>
                </div>
              </div>
            </div>
            <div class="main">
              <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
                <ul>
                  <li @click="searchAllData">
                    <div class="main-content" style="margin-left:30px;padding:5px 0px">全部标签类</div>
                  </li>
                  <li v-for="(item, index) in leftInfo" :key="index" @click="searchInfoTable(item)">
                    <div class="main-left" :style="{ background: item.colour }"></div>
                    <div class="main-content">{{ item.type }}</div>
                    <div class="main-right" v-if="btnShow">
                      <el-button type="text" size="mini" @click.stop="editClass(item)">编辑</el-button>
                      <el-button type="text" size="mini">|</el-button>
                      <el-button type="text" size="mini" @click.stop="deleteClass(item, index)">删除</el-button>
                    </div>
                  </li>
                </ul>
              </el-scrollbar>
            </div>
            <div class="footer" v-if="btnShow">
              <div class="footerBorder" @click="addClassDialog">
                + 添加一条分类
              </div>
            </div>
          </div>
          <div class="right list-padding">
            <div class="topBtn">
              <div class="header">
                <p></p>
                <h1>系统标签</h1>
              </div>
              <el-button type="primary" size='mini' @click="addLabelDialog">新增系统标签</el-button>
            </div>
            <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
              <el-table id="tableInfo" :data="tableData" style="width: 100%">
                <el-table-column type='index' label="序号" align="center"></el-table-column>
                <el-table-column prop="name" label="标签名称" align="center"></el-table-column>
                <el-table-column prop="type" label="标签类别" align="center"></el-table-column>
                <!-- <el-table-column prop="type" label="来源" align="center"></el-table-column> -->
                <el-table-column prop="status" label="状态" align="center">
                  <template slot-scope="scope">{{ scope.row.status == 0 ? '启用' : '停用' }}</template>
                </el-table-column>
                <el-table-column prop="labelTime" label="创建时间" align="center"></el-table-column>
                <el-table-column label="操作" align="center" fixed="right" v-if="btnShow">
                  <template slot-scope="scope">
                    <!-- <div style="height:30px;"> -->
                    <el-button @click="editLabel(scope.row, scope.$index)" type="text" size="small">编辑</el-button>
                    <!-- <el-button type="text" size="small" v-if="scope.row.status == 1" @click="disable(scope.row)">启用</el-button> -->
                    <!-- <el-button type="text" size="small" v-if="scope.row.status == 0" @click="disable(scope.row)">停用</el-button> -->
                    <el-button @click="deleteLabel(scope.row, scope.$index)" type="text" size="small">删除</el-button>
                    <el-button @click="configurationRulesClick(scope.row)" type="text" size="small">配置规则</el-button>
                    <el-button @click="lookPatientClick(scope.row)" type="text" size="small">查看患者</el-button>
                    <!-- </div> -->
                  </template>
                </el-table-column>
              </el-table>
            </el-scrollbar>
            <el-pagination style="text-align:right;margin-right:30px;margin-top:20px" background
              @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="searchForm.current" :page-size="searchForm.size"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
        <div class="doctor list-padding" v-if="activeName == 2">
          <div class="topBtn">
            <div class="header">
              <p></p>
              <h1>医生自定义标签</h1>
            </div>
            <el-button type="primary" size="small" @click="addDoctorTagClick(null)">新增标签</el-button>
          </div>
          <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
            <el-table id="tableInfo" :data="tableData" style="width: 98%">
              <el-table-column type='index' label="序号" align="center" fixed></el-table-column>
              <el-table-column prop="name" label="标签名称" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="doctorName" label="创建人" align="center">
                <template slot-scope="scope">{{ scope.row | getCreateName }}</template>
              </el-table-column>
              <el-table-column prop="hospitalName" label="归属机构" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="doctorTeam" label="归属团队" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column label="类型" align="center">
                <template slot-scope="scope">{{ scope.row.labelType | getLabelType }}</template>
              </el-table-column>
              <el-table-column label="医生操作权限" align="center" width="110">
                <template slot-scope="scope">{{ scope.row.operationPermissions | getOperationPermissions }}</template>
              </el-table-column>
              <el-table-column label="是否允许聊天" align="center" width="110">
                <template slot-scope="scope">{{ scope.row.disableIm | getDisableIm }}</template>
              </el-table-column>
              <el-table-column prop="status" label="状态" align="center">
                <template slot-scope="scope">{{ scope.row.status == 0 ? '启用' : '停用' }}</template>
              </el-table-column>
              <el-table-column prop="labelTime" label="创建时间" align="center" width="120"></el-table-column>
              <el-table-column fixed="right" label="操作" align="center" width="200">
                <template slot-scope="scope">
                  <el-button style="margin-right: 10px;" type="text" size="small"
                    @click="addDoctorTagClick(scope.row)">编辑</el-button>
                  <el-popconfirm title="此操作将移所有患者的该标签，请确认是否删除" confirm-button-text='确定' cancel-button-text='取消'
                    icon="el-icon-info" icon-color="red" @confirm="deleteDoctorTagClick(scope.row)">
                    <el-button slot="reference" type="text" size="small">删除</el-button>
                  </el-popconfirm>
                  <el-button style="margin-left: 10px;" @click="configurationRulesClick(scope.row)" type="text" size="small">配置规则</el-button>
                  <el-button @click="lookPatientClick(scope.row)" type="text" size="small">查看患者</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
          <el-pagination style="text-align:right;margin-right:30px;margin-top:20px" background
            @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="searchForm.current" :page-size="searchForm.size"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
        <!-- 标签模板 -->
        <div class="doctor" v-if="activeName == 3">
          <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
            <el-table id="tableInfo" :data="tableData" style="width: 98%">
              <el-table-column type='index' label="序号" align="center"></el-table-column>
              <el-table-column prop="name" label="标签名称" align="center"></el-table-column>
              <el-table-column prop="type" label="标签类别" align="center"></el-table-column>
              <el-table-column prop="labelTime" label="创建时间" align="center"></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" style="font-size:10px"
                    @click.stop="quoteClass(scope.row)">引用</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
          <el-pagination style="text-align:right;margin-right:30px;margin-top:20px" background
            @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="searchForm.current" :page-size="searchForm.size"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <AddClass ref="addClass" />
    <AddLabel ref="addLabel" />
    <AddConfigurationRules ref="addConfigurationRules" />
    <el-dialog :title="addDoctorTagForm.id ? '编辑标签' : '新增标签'" :visible.sync="addDoctorTagVisible" width="30%"
      :close-on-click-modal="false">
      <el-form :model="addDoctorTagForm" :rules="addDoctorTagRules" ref="addDoctorTagForm" label-width="100px"
        size="small">
        <el-form-item label="标签名称" prop="name">
          <el-input style="width: 90%;" v-model="addDoctorTagForm.name" placeholder="请输入14字内标签名称"
            maxlength="14"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="labelType">
          <span v-if="addDoctorTagForm.id">
            {{ addDoctorTagForm.labelType | getLabelType }}
          </span>
          <el-radio-group v-else v-model="addDoctorTagForm.labelType">
            <el-radio :label="2">团队</el-radio>
            <el-radio :label="1">个人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="addDoctorTagForm.labelType == 2" label="归属团队" prop="doctorTeamId">
          <span v-if="addDoctorTagForm.id">
            {{ addDoctorTagForm.doctorTeam }}
          </span>
          <el-select v-else style="width: 90%;" v-model="addDoctorTagForm.doctorTeamId" placeholder="请选择归属团队" filterable
            remote :remote-method="getDoctorTeamListRemote" :loading="getDoctorTeamListLoading"
            @change="doctorTeamChange">
            <el-option v-for="(item, index) in doctorTeamList" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addDoctorTagForm.labelType == 2" label="归属机构">
          <span>{{ addDoctorTagForm.hospitalName }}</span>
        </el-form-item>
        <el-form-item v-if="addDoctorTagForm.labelType == 1" label="归属医生" prop="doctorId">
          <span v-if="addDoctorTagForm.id">
            {{ addDoctorTagForm.doctorName }}
          </span>
          <el-select v-else style="width: 90%;" v-model="addDoctorTagForm.doctorId" placeholder="请选择归属医生" filterable
            remote :remote-method="getDoctorListRemote" :loading="getDoctorListLoading" @change="doctorChange">
            <el-option v-for="(item, index) in doctorList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医生操作权限" prop="operationPermissions">
          <el-select style="width: 90%;" v-model="addDoctorTagForm.operationPermissions" placeholder="请选择医生操作权限">
            <el-option v-for="(item, index) in operationPermissionsList" :key="index" :value="item.value"
              :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否允许聊天" prop="disableIm">
          <el-radio-group v-model="addDoctorTagForm.disableIm">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="addDoctorTagVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitAddDoctorTag('addDoctorTagForm')">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AddClass from "./components/addClass";
import AddLabel from "./components/addLabel";
import AddConfigurationRules from "./components/addConfigurationRules";
import {
  apiLabel_leftData,
  apiLabel_leftData_page,
  apiLabel_leftData_new,
  apiLabel_leftData_page_new,
  apiLabel_Delete,
  apiLabel_enable,
  apiClass_Delete,
  quoteLabelData,
  insertReturnId,
  updateDoctorLabel,
  deleteLabelForIds,
} from "./api/index";
import {
  api_doctor_team_search,
} from "@/api/doctorTeam.js";
import {
  api_doctor_search,
} from "@/api/docinfo";
import { DEEP_CLONE } from "@/utils/constants";
import local from "@/utils/local.js";
let that;
const defaultAddDoctorTagForm = {
  id: null,
  name: '',
  labelType: 2,
  hospitalId: '',
  hospitalName: '',
  doctorTeamId: '',
  doctorTeam: '',
  doctorId: '',
  doctorName: '',
  operationPermissions: 1,
  disableIm: 1,
  // 默认值
  type: '自定义',
  parentId: 1,
  source: 2,
  colour: '#7B93C7',
};
export default {
  components: {
    AddClass,
    AddLabel,
    AddConfigurationRules,
  },
  data() {
    return {
      breadList: [{ name: "系统设置" }, { name: "标签管理" }],
      searchForm: {
        redundant: "",
        status: "",
        source: 1,
        // parentId: "",
        current: 1,
        size: 10
      },
      total: 0,
      activeName: "1",
      tableData: [],
      leftInfo: [],
      loading: false,
      curIndex: 1,
      btnShow: true,
      // 添加标签弹框是否显示
      addDoctorTagVisible: false,
      addDoctorTagForm: Object.assign({}, defaultAddDoctorTagForm),
      addDoctorTagRules: {
        name: [
          { required: true, message: '请输入标签名称', trigger: 'blur' },
        ],
        doctorTeamId: [
          { required: true, message: '请选择归属团队', trigger: 'change' },
        ],
        doctorId: [
          { required: true, message: '请选择归属医生', trigger: 'change' },
        ],
      },
      operationPermissionsList: [
        {
          value: 1,
          label: '均可编辑',
        },
        {
          value: 2,
          label: '编辑患者',
        },
        {
          value: 3,
          label: '不可编辑',
        },
        {
          value: 4,
          label: '编辑标签',
        },
      ],
      getDoctorTeamListLoading: false,
      doctorTeamList: [],
      getDoctorListLoading: false,
      doctorList: [],
    };
  },
  beforeCreate() {
    that = this;
  },
  created() {
    this.leftData();
  },
  filters: {
    getCreateName(value) {
      if (value.createUserName) {
        return value.createUserName
      }
      if (value.doctorName) {
        return value.doctorName
      }
      return '--'
    },
    getLabelType(value) {
      if (value == 1) {
        return '个人'
      }
      if (value == 2) {
        return '团队'
      }
      return '--'
    },
    getOperationPermissions(value) {
      const findItem = that.operationPermissionsList.find((item) => {
        return item.value == value
      })
      if (findItem) {
        return findItem.label
      }
      return '--'
    },
    getDisableIm(value) {
      if (value == 1) {
        return '是'
      }
      if (value == 2) {
        return '否'
      }
      return '--'
    },
  },
  methods: {
    //列表切换事件
    handleClick(val) {
      if (val.name == 1) {
        this.loading = true;
        this.searchForm = {};
        this.searchForm.source = 1;
        this.leftData();
      } else if (val.name == 2) {
        this.loading = true;
        this.searchForm = {};
        this.searchForm.source = 2;
        this.rightData();
      } else {
        this.loading = true;
        this.searchForm = {};
        this.searchForm.source = 1;
        this.searchForm.companyId = this.$store.state.companyId;
        this.labelFormworkData();
      }
    },
    /**
     * @description:  点击左侧获取右侧列表信息
     * @param {*}
     * @return {*}
     */
    searchInfoTable(item) {
      this.loading = true;
      this.searchForm.parentId = item.id;
      this.rightData();
    },
    handleSizeChange(val) {
      this.searchForm.size = val;
      this.rightData();
    },
    handleCurrentChange(val) {
      this.searchForm.current = val;
      this.rightData();
    },
    /**
     * @description:  获取左侧列表接口
     * @param {*}
     * @return {*}
     */
    leftData() {
      this.loading = true;
      let obj = {
        parentId: 0
      };
      if (this.btnShow) {
        obj = {
          parentId: 0,
          syncSource: "DSICM"
        };
      } else {
        obj = {
          parentId: 0,
          syncSource: "WORKWECHAT"
        };
      }
      apiLabel_leftData_new(obj).then(res => {
        this.leftInfo = res.data;
        this.rightData();
      });
    },
    // 引用
    async quoteClass(row) {
      let res = await quoteLabelData(row.id);
      if (res.code === 0 && res.data) {
        this.$message.success("引用成功");
      } else {
        this.$message.error("引用失败");
      }
    },
    // 标签模板数据
    labelFormworkData() {
      apiLabel_leftData_page_new({ ...this.searchForm })
        .then(res => {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    /**
     * @description:  获取右侧列表接口
     * @param {*}
     * @return {*}
     */
    rightData() {
      if (this.searchForm.source == 1) {
        if (this.btnShow) {
          this.searchForm.syncSource = "DSICM";
        } else {
          this.searchForm.syncSource = "WORKWECHAT";
        }
      } else {
        delete this.searchForm.syncSource;
      }
      apiLabel_leftData_page_new({ ...this.searchForm })
        .then(res => {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    //获取全部标签
    searchAllData() {
      this.loading = true;
      this.searchForm.redundant = "";
      this.searchForm.status = "";
      this.searchForm.source = 1;
      // this.searchForm.parentId = "";
      delete this.searchForm.parentId;
      this.searchForm.current = 1;
      this.searchForm.size = 10;
      this.rightData();
    },
    //模糊查询
    searchBtn() {
      this.loading = true;
      delete this.searchForm.parentId;
      this.rightData();
    },
    allLabelSearch() {
      this.loading = true;
      this.searchForm.current = 1;
      this.searchForm.size = 10;
      delete this.searchForm.parentId;
      // this.searchForm.parentId = "";
      this.rightData();
    },
    /**
     * @description:  新增  编辑 删除 类别弹窗
     * @param {*}
     * @return {*}
     */
    addClassDialog() {
      this.$refs.addClass.openDialog();
    },
    //编辑类别弹窗
    editClass(item) {
      this.$refs.addClass.editDialog(item);
    },
    //删除类别
    deleteClass(item, index) {
      this.$confirm(
        "请确认是否删除当前标签分类及其下属所有标签？",
        "确认信息",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          customClass: "message-confirm-style"
        }
      ).then(() => {
        apiClass_Delete(item.id).then(res => {
          if (res.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.leftInfo.splice(index, 1);
            this.rightData();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    /**
     * @description:  新增 编辑 启用停用 删除 标签弹窗
     * @param {*}
     * @return {*}
     */
    addLabelDialog() {
      this.$refs.addLabel.openDialog();
    },
    //编辑标签
    editLabel(row) {
      this.$refs.addLabel.editDialog(row);
    },
    //启用 停用
    disable(row) {
      apiLabel_enable(row.id).then(res => {
        if (res.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          row.status = !row.status;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //删除
    deleteLabel(row, index) {
      this.$confirm("请确认是否删除当前标签", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      }).then(() => {
        apiLabel_Delete(row.id).then(res => {
          if (res.code == 0) {
            this.$message({
              message: "成功",
              type: "success"
            });
            this.tableData.splice(index, 1);
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 配置规则弹框显示
    configurationRulesClick(row) {
      this.$refs.addConfigurationRules.openDialog(row)
    },
    // 查看患者
    lookPatientClick(row) {
      this.$router.push({
        path: '/groupList',
        query: { id: row.id, from: 'label', labelName: row.name },
      });
    },
    acquireClick() {
      //获取企业微信标签
      this.$confirm(
        "操作执行后将从企业微信标签库中获取最新的标签数据，是否继续？",
        "确认信息",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "是",
          cancelButtonText: "否",
          customClass: "message-confirm-style"
        }
      )
        .then(() => { })
        .catch(() => { });
    },
    renewalClick() {
      //更新企业微信标签
      this.$confirm(
        "操作执行后将向企业微信标签库中发送最新自定义标签数据，是否继续？",
        "确认信息",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "是",
          cancelButtonText: "否",
          customClass: "message-confirm-style"
        }
      )
        .then(() => { })
        .catch(() => { });
    },
    resetClick() {
      this.searchForm.redundant = "";
      this.searchForm.status = "";
      this.searchForm.current = 1;
      this.searchForm.size = 10;
      this.rightData();
    },
    changeSymp(i) {
      this.curIndex = i;
      delete this.searchForm.parentId;
      // this.searchForm.parentId = "";
      if (i == 1) {
        this.btnShow = true;
      } else {
        this.btnShow = false;
      }
      this.leftData();
    },
    // 添加标签
    addDoctorTagClick(row) {
      if (row) {
        this.addDoctorTagForm = DEEP_CLONE(row)
      } else {
        this.addDoctorTagForm = DEEP_CLONE(defaultAddDoctorTagForm)
      }
      this.doctorTeamList = []
      this.doctorList = []
      this.addDoctorTagVisible = true
    },
    // 归属团队查询
    getDoctorTeamListRemote(query) {
      if (query !== '') {
        this.getDoctorTeamListLoading = true;
        var searchParams = {
          size: 10000,
          doctorTeamName: query,
          companyId: this.$store.state.companyId,
          platformId: this.$store.state.platformId,
        }
        api_doctor_team_search(searchParams).then(res => {
          if (res.code == 0) {
            this.getDoctorTeamListLoading = false
            this.doctorTeamList = res.data.records
          }
        });
      } else {
        this.doctorTeamList = []
      }
    },
    // 归属团队选择完回调
    doctorTeamChange(value) {
      this.doctorTeamList.forEach(item => {
        if (item.id == value) {
          this.addDoctorTagForm.doctorTeam = item.name
          this.addDoctorTagForm.hospitalId = item.hospitalId
          this.addDoctorTagForm.hospitalName = item.hospitalName
        }
      })
    },
    // 归属医生查询
    getDoctorListRemote(query) {
      if (query !== '') {
        this.getDoctorListLoading = true;
        var searchParams = {
          size: 10000,
          doctorName: query,
          doctorType: 1,
        }
        api_doctor_search(searchParams).then(res => {
          if (res.code == 0) {
            this.getDoctorListLoading = false
            this.doctorList = res.data.records
          }
        });
      } else {
        this.doctorList = []
      }
    },
    doctorChange(value) {
      this.doctorList.forEach(item => {
        if (item.id == value) {
          this.addDoctorTagForm.doctorName = item.name
        }
      })
    },
    submitAddDoctorTag(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addDoctorTagForm.labelType == 1) {
            // 个人
            this.addDoctorTagForm.doctorTeamId = null
            this.addDoctorTagForm.doctorTeam = null
          }
          if (this.addDoctorTagForm.labelType == 2) {
            // 团队
            this.addDoctorTagForm.doctorId = null
            this.addDoctorTagForm.doctorName = null
          }
          this.addDoctorTagForm.companyId = this.$store.state.companyId || local.get("companyId")
          this.addDoctorTagForm.platformId = this.$store.state.platformId || local.get("platformId")
          if (this.addDoctorTagForm.id) {
            updateDoctorLabel(this.addDoctorTagForm).then(res => {
              if (res.code == 0) {
                this.$message.success('编辑标签成功')
                this.addDoctorTagVisible = false
                this.rightData()
              }
            })
          } else {
            insertReturnId(this.addDoctorTagForm).then(res => {
              if (res.code == 0) {
                this.$message.success('新增标签成功')
                this.addDoctorTagVisible = false
                this.rightData()
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    deleteDoctorTagClick(row) {
      deleteLabelForIds([row.id]).then(res => {
        if (res.code == 0) {
          this.$message.success('删除标签成功')
          this.rightData()
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
@import "./index";

.list-padding {
  padding-bottom: 112px !important;
}

.tabs {
  margin-top: 16px;
}

.tab-box {
  width: 180px;
  height: 32px;
  background: #edf0f2;
  border-radius: 2px;
  padding: 2px;
  display: flex;
  align-items: center;
  cursor: pointer;

  div {
    width: 88px;
    border-radius: 2px;
    text-align: center;
    line-height: 28px;
    font-weight: bold;
  }

  .checked {
    background: #ffffff;
    color: #1a7bfc;
  }
}

.topBtn {
  margin-bottom: 20px;
  padding-right: 20px;
}
</style>
